const persianNumbers = [/۰/g, /۱/g, /۲/g, /۳/g, /۴/g, /۵/g, /۶/g, /۷/g, /۸/g, /۹/g];
const arabicNumbers = [/٠/g, /١/g, /٢/g, /٣/g, /٤/g, /٥/g, /٦/g, /٧/g, /٨/g, /٩/g];
const englishNumbers = [/0/g, /1/g, /2/g, /3/g, /4/g, /5/g, /6/g, /7/g, /8/g, /9/g];


export const fixNumbers = (numb: any) => {
  for (let i = 0; i < 10; i++) {
    numb = numb.replace(persianNumbers[i], i).replace(englishNumbers[i], i);
    numb = numb.replace(arabicNumbers[i], i).replace(englishNumbers[i], i);
  }
  return numb;
}
export const FixSimNumbers = (numb: any) => {
  const sim = fixNumbers(numb);
  if (sim.includes("+98")) {
    return sim;
  } else {
    return "+98";
  }
};

export const isJsonString = (str: any) => {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
}